import "./style.css"
import { Route, Routes, useLocation } from "react-router-dom";
import PaginaInicial from "./Paginas/PaginaInicial";
import PaginaErro from "./Paginas/PaginaErro";
import Formacoes from "./Paginas/Formacoes";
import PaginaBase from "Paginas/PaginaBase";
import Projetos from "Paginas/Projetos";
import Contato from "Paginas/Contato";
import { AnimatePresence } from "framer-motion";

function AppRoutes() {

  let location = useLocation()

  return (
    <AnimatePresence mode='wait' initial={false}>
      <Routes location={location} key={location.id}>
        <Route path="/" element={<PaginaBase />}>
          <Route index element={<PaginaInicial />} />
          <Route path="/Contato" element={<Contato />} />
          <Route path="/Projetos" element={<Projetos />} />
          <Route path="/Formacao/:id" element={<Formacoes />} />
          <Route path="*" element={<PaginaErro />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

export default AppRoutes;
